import cloudServiceModule from '../cloudService.module';

class TokenApiService {
    constructor(__env, httpUtil, $q) {
        this.__env = __env;
        this.httpUtil = httpUtil;
        this.$q = $q;
    }

    getToken(cloudToken, source) {
        if (!cloudToken || !source) {
            return this.$q.reject();
        }

        return this.httpUtil.post(
            `${this.__env.cloudApiUrl}/ci/v1/${source}/token`,
            {
                cloudToken: cloudToken
            }
        );
    }
}

export default cloudServiceModule.service('tokenApiService', TokenApiService);



// WEBPACK FOOTER //
// ./modules/cloudService/token/tokenApi.service.js